export default {
  fi: {
    ForgotSuccessScene: {
      checkEmail: 'Tarkista sähköpostisi',
      linkSended: 'Olemme lähettäneet sinulle linkin salasanan vaihtamiseen.',
      backLink: 'Takaisin kirjautumissivulle',
    },
  },
};
